import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Lightweight singleton-ish settings fetcher.
 * - Caches the fetched settings on `window.__es_settings` so opening multiple
 *   "New" modals doesn't refetch.
 * - Returns `null` while loading.
 *
 * Defaults mirror DEFAULT_SETTINGS in backend/server.py.
 */
const FALLBACK = {
  Default_Discount_Percent: 0,
  Default_Pickup_Lead_Days: 3,
};

let cache = null;
let pending = null;

export function useAppSettings() {
  const [settings, setSettings] = useState(cache);

  useEffect(() => {
    if (cache) return;
    if (!pending) {
      pending = api.get("/settings")
        .then(({ data }) => { cache = data; return data; })
        .catch(() => { cache = { ...FALLBACK }; return cache; })
        .finally(() => { pending = null; });
    }
    pending.then((d) => setSettings(d));
  }, []);

  return settings || FALLBACK;
}

export function invalidateAppSettingsCache() {
  cache = null;
  pending = null;
}
